export default {
  THIS_COLUMN: 'this-column',
  ALL_COLUMNS: 'all-columns',
};
